export const footerWrapper = { background: "#F6F9FC" };

export const footerHeading = {
  fontWeight: 700,
  fontSize: "2.625rem",
  lineHeight: "3rem",
};

export const divider = { margin: "5.5rem 0 2.813rem" };

export const footerLink = {
  fontSize: 18,
  cursor: "pointer",
  ":hover": { opacity: ".5", transition: ".3s" },
};
